import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import Demographics from "./Demographics";
import AreaData from "./AreaData";

class DemographicsSection extends Component {
  state = {
    activeIndex: 0,
    rows: [],
    martinRecord: undefined,
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.martinRecord !== nextProps.martinRecord) {
      this.setState({
        martinRecord: nextProps.martinRecord,
      });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    const martinRecord = props.martinRecord;
    if (martinRecord !== undefined) {
      const searchResults = _.get(martinRecord, "searchResults");
      const recLength = searchResults !== undefined ? searchResults.length : 0;
      if (recLength === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      } else {
        rows.push(
          <Table.Row key={`rep_demo_row`}>
            <Table.Cell>
              <Demographics record={martinRecord} {...props} />
            </Table.Cell>
            <Table.Cell>
              <AreaData record={martinRecord} {...props} />
            </Table.Cell>
          </Table.Row>
        );
      }
      props.updateItemCountBySection(props.sectionName, recLength);
      this.setState({
        rows,
        activeIndex: 0,
        martinRecord,
      });
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`DemoTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Demographics
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`DemoBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default DemographicsSection;



// WEBPACK FOOTER //
// ./src/components/reports/DemographicsSection.js